/**
 * EKSELENS360 brand hierarchy — single source of truth.
 *
 *   EKSELENS360 (master / umbrella)
 *      └── <SERVICE>360 (one sub-brand per consulting service)
 *
 * Used on:
 *   - ServicePage hero (eyebrow badge)
 *   - Admin toolkits panel (each item carries the matching sub-brand)
 *   - WeasyPrint toolkit PDFs (cover badge — see /app/backend/pdf_renderer.py)
 */
export const MASTER_BRAND = "EKSELENS360";

export const SUB_BRANDS = {
  "ai-readiness-and-adoption": {
    code: "AI360",
    tagline: "AI readiness, governance & adoption.",
  },
  "digital-and-technology-transformation": {
    code: "DIGITAL360",
    tagline: "Technology transformation, end to end.",
  },
  "project-programme-and-pmo-improvement": {
    code: "PMO360",
    tagline: "Programme & PMO uplift that drives decisions.",
  },
  "business-change-and-adoption": {
    code: "CHANGE360",
    tagline: "Adoption is the outcome — not communication.",
  },
  "service-and-operating-model-transformation": {
    code: "OPERATING360",
    tagline: "Designing the way the business works.",
  },
  "supplier-and-technology-value-optimisation": {
    code: "SUPPLIER360",
    tagline: "Surface savings; remove renewal risk.",
  },
  "it-service-management-and-operational-excellence": {
    code: "ITSM360",
    tagline: "From firefighting to proactive service management.",
  },
  "data-insight-and-performance": {
    code: "DATA360",
    tagline: "Data that drives decisions, not dashboards.",
  },
  "benefits-realisation-and-assurance": {
    code: "BENEFITS360",
    tagline: "Promised benefits, evidenced and realised.",
  },
  "governance-and-delivery-control": {
    code: "GOVERN360",
    tagline: "Decision rights and delivery confidence.",
  },
  "capability-and-training-needs-analysis": {
    code: "CAPABILITY360",
    tagline: "Capability the business actually needs.",
  },
  "stakeholder-engagement-and-communications": {
    code: "STAKEHOLDER360",
    tagline: "Internal alignment that survives go-live.",
  },
};

export const subBrandFor = (slug) => SUB_BRANDS[slug] || null;
